/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Filter_All_SportsInputs */

const en_ui_filter_all_sports = /** @type {(inputs: Ui_Filter_All_SportsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`all sports`)
};

const de_ui_filter_all_sports = /** @type {(inputs: Ui_Filter_All_SportsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`alle Sportarten`)
};

/**
* | output |
* | --- |
* | "all sports" |
*
* @param {Ui_Filter_All_SportsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_filter_all_sports = /** @type {((inputs?: Ui_Filter_All_SportsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Filter_All_SportsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_filter_all_sports(inputs)
	return de_ui_filter_all_sports(inputs)
});